<script lang="ts" setup>
import translationsService, {
  CSVTranslation,
  Validation,
} from '@/services/translations.service';
import { ref } from 'vue';

const file = ref<File | null>(null);
const result = ref<{ faultyLines: Validation[]; updates: CSVTranslation[] }>({
  faultyLines: [],
  updates: [],
});

async function updateTranslations() {
  if (file.value) {
    const response = await translationsService.update(file.value);

    result.value = response.data;

    file.value = null;
  }
}

async function downloadCSV() {
  window.open(
    `${document.location.protocol}//${document.location.host}/api/translation/download`,
    'new',
  );
}

const fileRules = [
  (value: File) => {
    if (value) return true;

    return 'File is required';
  },
  (value: File[]) => {
    if (value && value.length && value[0].type?.indexOf('csv') !== -1) {
      return true;
    }

    return 'File must be of type CSV';
  },
];
</script>
<template>
  <v-container>
    <h2>Translations</h2>
    <p>
      Download a csv of missing translations or upload a CSV to update
      translations in the database.
    </p>

    <v-form @submit.prevent="updateTranslations" style="max-width: 600px">
      <v-row>
        <v-col cols="9"
          ><p class="ml-10 mt-4">Download missing translations</p></v-col
        >
        <v-col cols="3">
          <v-btn
            type="button"
            color="success"
            block
            class="mt-2"
            @click="downloadCSV"
            >Download</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="9">
          <v-file-input
            v-model="file"
            label="CSV"
            filter-by-type="text/csv"
            :rules="fileRules"
          />
        </v-col>
        <v-col cols="3">
          <v-btn type="submit" color="primary" block class="mt-2">Update</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-alert type="warning" class="mt-8 mb-8"
            >Ensure the CSV is correct before updating. And ask Carl to make a
            database backup before you do this.
          </v-alert>
        </v-col>
      </v-row>
    </v-form>
    <v-alert type="success" class="mt-8 mb-8" v-if="result.updates.length"
      >{{ result.updates.length }} translations have been updated.
    </v-alert>
    <v-alert type="info" class="mt-8 mb-8" v-if="result.faultyLines.length"
      >{{ result.faultyLines.length }} translations failed to be updated have
      been updated. Check rows
      {{ result.faultyLines.map((l) => l.index).join(', ') }} and try again.
    </v-alert>
  </v-container>
</template>
